export default Object.freeze({
    USER_MAIN: 'USER_MAIN',
    USER_AVATAR: 'USER_AVATAR',
    COMPANY_MAIN: 'COMPANY_MAIN',
    COMPANY_AVATAR: 'COMPANY_AVATAR',
    COMPANY_COVER: 'COMPANY_COVER',
    COMPANY_OTHER: 'COMPANY_OTHER',
    OFFER_MAIN: 'OFFER_MAIN',
    OFFER_THUMBNAIL: 'OFFER_THUMBNAIL',
    OFFER_OTHER: 'OFFER_OTHER',
})
